const faqs = [
    { 
        id: 1, 
        heading: 'How do we charge for landscaping projects?',
        content: 'Our pricing depends on the scope of the project, including factors such as the size of the area, the complexity of the design, and the materials used. We provide a detailed estimate after assessing your space and discussing your preferences.',
    }, 
    { 
        id: 2,
        heading: 'Do we offer free consultations?',
        content: 'Yes, we offer free consultations where we discuss your vision for your outdoor space, provide expert advice, and create a custom plan that fits your budget.',
    },
    {
        id: 3, 
        heading: 'What areas do we serve?',
        content: 'We proudly serve a wide range of areas. Contact us to check if we cover your specific location. We are committed to helping homeowners create beautiful outdoor spaces.',
    },
    {
        id: 4,
        heading: 'Do we use subcontractors?',
        content: 'We only use trusted subcontractors for specialized tasks when necessary. However, most of the work is performed by our in-house, experienced landscaping team to ensure the highest quality.',
    },
    {
        id: 5,
        heading: 'How long does it take to complete a landscaping project?',
        content: 'The timeline for completing a landscaping project depends on the size and complexity of the work. We will provide an estimated completion date after our initial consultation and keep you updated throughout the process.',
    },
];

export default faqs;